const removeTableFallback = (chartId) => {
  const fallback = document.querySelector(`[data-chart-id="${chartId}"]`);
  if (fallback) {
    fallback.remove();
  }
};

export { removeTableFallback };
